import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { EntregasTransportadorComponent } from './entregas-transportador/entregas-transportador.component';




const routes: Routes = [
  {
    path: "login",
    component: LoginComponent,
    data: { title: "Login" },
  },
  {
    path: "inicio",
    loadChildren: () =>
      import("./modules/inicio/inicio.module").then((m) => m.InicioModule),
    data: { title: "Inicio" },
  },
  {
    path: "creacionusuarios",
    loadChildren: () =>
      import("./modules/creacionusuarios/creacionusuarios.module").then((m) => m.CreacionusuariosModule),
    data: { title: "Creacion Usuarios" },
  },
  {
    path: "modificausuario",
    loadChildren: () =>
      import("./modules/modificausurio/modificausurio.module").then((m) => m.ModificausurioModule),
    data: { title: "Modificar Usuario" },
  },
  {
    path: "gestionmaestras",
    loadChildren: () =>
      import("./modules/gestion-maestras/gestion-maestras.module").then((m) => m.GestionMaestrasModule),
    data: { title: "Gestion Maestras" },
  },
  {
    path: "asignacionservicios",
    loadChildren: () =>
      import("./modules/asignacion-servicios/asignacion-servicios.module").then((m) => m.AsignacionServiciosModule),
    data: { title: "Asignacion Servicios" },
  },
  {
    path: "serviciosasignados",
    loadChildren: () =>
      import("./modules/serviciosasignados/serviciosasignados.module").then((m) => m.ServiciosasignadosModule),
    data: { title: "Asignacion Asignados" },
  },
  {
    path: "administracionagencia",
    loadChildren: () =>
      import("./modules/administracion-agencia/administracion-agencia.module").then((m) => m.AdministracionAgenciaModule),
    data: { title: "Administracion Agencias" },
  },
  {
    path: "asignaciontransportadorvehiculo",
    loadChildren: () =>
      import("./modules/asignacion-transportador-vehiculo/asignacion-transportador-vehiculo.module").then((m) => m.AsignacionTransportadorVehiculoModule),
    data: { title: "Asignacion Transportador" },
  },
  {
    path: "administraciontiposnovedades",
    loadChildren: () =>
      import("./modules/administracion-tipos-novedades/administracion-tipos-novedades.module").then((m) => m.AdministracionTiposNovedadesModule),
    data: { title: "Administracion Tipos Novedades" },
  },
  {
    path: "administracionmotivos",
    loadChildren: () =>
      import("./modules/administracion-motivos/administracion-motivos.module").then((m) => m.AdministracionMotivosModule),
    data: { title: "Administracion Motivos" },
  },
  {
    path: "entregas",
    loadChildren: () =>
      import("./modules/entregas/entregas.module").then((m) => m.EntregasModule),
    data: { title: "Entregas" },
  },
  {
    path: 'entregastransportador',
    component: EntregasTransportadorComponent,
    data: { title: 'Entregas Transportador' }
  },
  {
    path: "carguexusuario",
    loadChildren: () =>
      import("./modules/cargues-usuario/cargues-usuario.module").then((m) => m.CarguesUsuarioModule),
    data: { title: "Cargues por usuario" },
  },
  {
    path: "rutaentregas",
    loadChildren: () =>
      import("./modules/ruta-entregas/ruta-entregas.module").then((m) => m.RutaEntregasModule),
    data: { title: "Ruta Entregas" },
  },
  {
    path: "encuestasfijas",
    loadChildren: () =>
      import("./modules/encuestas-fijas/encuestas-fijas.module").then((m) => m.EncuestasFijasModule),
    data: { title: "Gestion Encuestas" },
  },
    {
      path: 'administracionmensajes',
      loadChildren: () =>
      import("./modules/administracion-mensajes/administracion-mensajes.module").then((m) => m.AdministracionMensajesModule),
      data: { title: 'Administracion Mensajes' }
    },
    {
      path: 'reporteencuestas',
      loadChildren: () =>
      import("./modules/reporte-encuestas/reporte-encuestas.module").then((m) => m.ReporteEncuestasModule),
      data: { title: 'Reporte Encuestas' } },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
export const routingComponents = [
  LoginComponent,
];
